import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const User2: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '8', r: '5' }],
    ['path', { d: 'M20 21a8 8 0 1 0-16 0' }],
  ],
];

export default User2;
